@@ -0,0 +1,162 @@
<template>
  <section class="r-worker-kind">
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="id"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Worker Kinds"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Worker Kind
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.group="{item}">
          <div>{{ getGroupName(item.group) }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-worker-kind-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import { WorkerKind } from "@/modules/redactor/models/worker/WorkerKind";
import RWorkerKindDialog from "@/modules/redactor/views/worker-kind/r-worker-kind-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-worker-kind-page",
  components: {RDialogPreviewCollection, RWorkerKindDialog, AcDataTable},
  data: () => ({
    search: "",
    headers: [
      {text: "ID", value: "id"},
      {text: "Name", value: "name"},
      {text: "Order", value: "order"},
      {text: "Key", value: "key"},
      {text: "Group", value: "group"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(WorkerKind)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    isDuplicate(newItem) {
      return this.items.some(item =>
        (item.id === newItem.id || item.key === newItem.key) && item.uid !== newItem.uid
      );
    },
    getGroupName(key){
        return WorkerKind.GROUPS.get(key);
    },
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.isDuplicate(result)) {
              this.$alert("Duplicate Worker Key or ID detected!");
              return;
            }
            RedactorUtils.pushWorkerKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(data) {
      this.$refs['dialog'].show(ViewRules.UPDATE, data.clone()).then(
          result => {
            if (this.isDuplicate(result)) {
              this.$alert("Duplicate Worker Key or ID detected!");
              return;
            }
            RedactorUtils.pushWorkerKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(data) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeWorkerKind(data).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkWorkerKinds(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushWorkerKind(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, WorkerKind, "worker-kind")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getWorkerKinds();
  }
}
</script>
